const apiKey = "60F5B299-85B6-4EF9-9623-0C29A71DE0B3";
const aalApiKey = "76f2c323-6fe7-4de0-b24c-bf0f28b07f8e";
const muiLicenseKey = "04e0b08de5327ba30e6cc44a704e5bf7Tz0xMzE2ODIsRT0xODE3NDIzOTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MSxBVD1tdWx0aSxLVj0y";

const environments = {
    // Local development. Also what `react-scripts test` (Jest) falls back to.
    development: {
        appVersion: "1.0.49",
        baseUrlBLU: "http://localhost:57523/api/blu/v1/",
        baseUrlMAT: "http://localhost:57523/api/mat/v1",
        baseUrlCAM: "http://localhost:5005/api/cam/",
        baseUrlCAT: 'http://localhost:5005/api/cat/v1/',
        baseUrl: [
            "http://localhost:5250/",
            "http://localhost:57523/api/ric/v1/",
            "http://localhost:5005/api/faq/v1/",
            "https://localhost:7187/api/"
        ],
        apiKey,
        muiLicenseKey,
        aalBaseUrl: "https://localhost:44343/",
        aalApiKey,
    },
    // QA — deployed from `qa` (yellow-tree SWA), against the test APIs.
    test: {
        appVersion: "1.0.49",
        baseUrlBLU: "https://testspapi.associatedasset.com/api/blu/v1/",
        baseUrlMAT: "https://testspapi.associatedasset.com/api/mat/v1",
        baseUrlCAM: "https://testspapi.associatedasset.com/api/cam/",
        baseUrlCAT: 'https://testspapi.associatedasset.com/api/cat/v1/',
        baseUrl: [
            "https://devallaccesshub.azurewebsites.net/",
            "https://testspapi.associatedasset.com/api/ric/v1/",
            "https://testspapi.associatedasset.com/api/faq/v1/",
            "https://testsmsblast.associatedasset.com/api/"
        ],
        apiKey,
        muiLicenseKey,
        aalBaseUrl: "https://testmobileweb.associatedasset.com",
        aalApiKey,
    },
    // Pre-production / UAT — deployed from `staging` (agreeable-sand SWA),
    // against the homolog SPA API on port 8444.
    homolog: {
        appVersion: "1.0.48",
        baseUrlBLU: "https://testspapi.associatedasset.com:8444/api/blu/v1/",
        baseUrlMAT: "https://testspapi.associatedasset.com:8444/api/mat/v1",
        baseUrlCAM: "https://testspapi.associatedasset.com:8444/api/cam/",
        baseUrlCAT: 'https://testspapi.associatedasset.com:8444/api/cat/v1/',
        baseUrl: [
            "https://devallaccesshub.azurewebsites.net/",
            "https://testspapi.associatedasset.com:8444/api/ric/v1/",
            "https://testspapi.associatedasset.com:8444/api/faq/v1/",
            "https://testsmsblast.associatedasset.com/api/"
        ],
        apiKey,
        muiLicenseKey,
        aalBaseUrl: "https://testmobileweb.associatedasset.com",
        aalApiKey,
    },
    // PRODUCTION — deployed from `main` (wonderful-ground SWA). Real customer
    // traffic; never point these at test hosts.
    production: {
        appVersion: "1.0.48",
        baseUrlBLU: "https://spapi.associatedasset.com/api/blu/v1/",
        baseUrlMAT: "https://spapi.associatedasset.com/api/mat/v1",
        baseUrlCAM: "https://spapi.associatedasset.com/api/cam/",
        baseUrlCAT: 'https://spapi.associatedasset.com/api/cat/v1/',
        baseUrl: [
            "https://aamallaccesshubapi.azurewebsites.net/",
            "https://spapi.associatedasset.com/api/ric/v1/",
            "https://spapi.associatedasset.com/api/faq/v1/",
            "https://smsblast.associatedasset.com/api/"
        ],
        apiKey,
        muiLicenseKey,
        aalBaseUrl: "https://mobileweb.associatedasset.com",
        aalApiKey,
    },
};

const getEnv = () => {
    const env = process.env.REACT_APP_ENV || "development";
    const config = environments[env];

    if (!config) {
        console.error(`Environment configuration for '${env}' not found.`);
        return null;
    }

    console.log(env, "REACT_APP_ENV");
    console.log(config, "Environment Configuration");
    return config;
};

export const env = getEnv();
